import "./MeetingBubblePage.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import { getSurveyTypeDisplay } from "@teams/cards";
import { TeamsSurveyTypes } from "@teams/types";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import { useUserInfo } from "../../../_shared/actions/useUserInfo";
import ConfirmationAnimation from "../../../_shared/assets/success-animation.svg";
import { useTeamsContext } from "../../../_shared/state/TeamsContextProvider";
import { clientEventTracker } from "../../../_shared/utils/clientTelemetry";
import { TriviaTakingForm } from "../components/trivia/TriviaTakingForm";
import { HotTakeInformation } from "./components/hotTake/HotTakeInformation";
import { IcebreakerInformation } from "./components/icebreaker/IcebreakerInformation";
import { QnaInformation } from "./components/qna/QnaInformation";
import { SurveyTakingForm } from "./components/SurveyTakingForm";

const TRACKING = "meeting-bubble";

export const MeetingBubblePage: React.FC = () => {
  const { teamsContext } = useTeamsContext();
  const { type, surveyId } = useParams<{ type: TeamsSurveyTypes; surveyId: string }>();
  const { user } = useUserInfo();

  useEffect(() => {
    clientEventTracker.track("meeting bubble viewed", user, {
      type,
      surveyId,
      hostClientType: teamsContext?.app.host.clientType,
      meetingType: teamsContext?.chat?.id?.includes("meeting_") ? "standard" : "channel",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, surveyId]);

  return (
    <div className="meeting-bubble-page">
      {(type === "poll" || type === "survey" || type === "quiz") && (
        <SurveyTaking surveyId={surveyId} />
      )}
      {type === "qna" && <QnaInformation surveyId={surveyId} />}
      {type === "trivia" && <TriviaTakingForm surveyId={surveyId} trackingSource={TRACKING} />}
      {type === "icebreaker" && (
        <div style={{ padding: "0 25px 25px 25px" }}>
          <IcebreakerInformation surveyId={surveyId} maxRespondents={3} />
        </div>
      )}
      {type === "hot-take" && (
        <div style={{ padding: "0 25px 25px 25px" }}>
          <HotTakeInformation surveyId={surveyId} preview answerForm />
        </div>
      )}
    </div>
  );
};

const SurveyTaking: React.FC<{ surveyId: string }> = ({ surveyId }) => {
  const { teamsContext } = useTeamsContext();
  const [hasCompleted, setHasCompleted] = useState<string>();

  return (
    <div className="meeting-bubble-page__survey-form">
      {!hasCompleted && (
        <SurveyTakingForm
          contextOrApiToken={teamsContext}
          surveyId={surveyId}
          trackingSource={TRACKING}
          onCompleted={survey => {
            setHasCompleted(`You've completed this ${getSurveyTypeDisplay(survey.type)}!`);
          }}
        />
      )}
      {hasCompleted && (
        <Flex fill column vAlign="center" hAlign="center" gap="gap.medium">
          <img src={ConfirmationAnimation} height={100} alt="confirmed" />
          <Text content={hasCompleted} size="large" weight="bold" align="center" />
        </Flex>
      )}
    </div>
  );
};
